export default __webpack_public_path__ + "d6726d0e00676f003c3063ac2489acd7.png";